import React, { useContext, useEffect, useState } from "react";
import { Badge, Col, Container, Row, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import schoolApi from "../../api/schoolApi";
// import DashboardRoom from "../Dashboard/DashboardRoom";
import Helmet from "react-helmet";
import ListGroup from "react-bootstrap/ListGroup";
import Form from "react-bootstrap/Form";
import moment, { now } from "moment";
import { saveAs } from "file-saver";
import { ToastContainer, toast } from "react-toastify";
import { useOutletContext } from "react-router-dom";
import fileDownload from "js-file-download";
import * as constants from "../../constants/CONSTANT";
import jwt_decode from "jwt-decode";
import { SessionContext } from "../SessionProvider";

const AssigmentList = () => {
  const { selectedSessionId, setSelectedSessionId } = useContext(SessionContext);

  const navigate = useNavigate();
  // const [assigmentListData, setAssigmentData] = useState({});
  // const [selectedSessionId, setSessionId] = useState({});
  const [showFilterModal, setShowFilterModal] = useState(false);
  // const [selectedStudentId, setStudentId] = useState();
  const [studentData, setStudentDetails] = useState();
  const [assigmentDetails, setAssigmentDetails] = useState({
    classid: "",
  });
  const [selectedStudent, setStudent] = useOutletContext();
  const [dateWiseAssigmentData, setDateWiseAssigmentData] = useState({});
  const [validated, setValidated] = useState(false);
  const [assigmentFilterDetails, setAssigmentFilterDetails] = useState({});
  const [dropDownValue, setDropDownValue] = useState({});
  const [tempBody, setTempBody] = useState({});

  useEffect(() => {
    fetchData();
  }, [selectedStudent , selectedSessionId]);

  async function fetchData() {
    try {
      if (selectedStudent) {
        console.log("Student-Id-Before-API-Called==>>", selectedStudent);
        // let studentDetails = await schoolApi.fetchStudentsById(selectedStudent.id);
        let studentDetails = await schoolApi.fetchStudentsById(selectedStudent.id , selectedSessionId);
        console.log("studentDetails-by-id", studentDetails);

        if (studentDetails.studentRec && studentDetails.success === true) {
          //assigmentDetails.classid = studentDetails?.studentRec?.classid;
          setStudentDetails(studentDetails?.studentRec);
          // setStudentApi(true);
          // } else {
          //   setStudentDetails([]);
          // }
        }
        
        console.log("assigmentDetails@@@+>", assigmentDetails);
        console.log("selectedStudent.session_id@!=>", selectedStudent.session_id);
        assigmentDetails.classid = studentDetails?.studentRec?.classid;
        assigmentDetails.section_id = studentDetails?.studentRec?.section_id;
        
        const result = await schoolApi.searchAssimentsRecords(
          assigmentDetails,
          // selectedStudent.session_id
          // studentDetails?.studentRec?.session_id,
          selectedSessionId,
        );

        if (result?.result) {
          setDateWiseAssigmentData(result.result);
          setTempBody(result.result);
          setDropDownValue(result.result);
        } else {
          setDateWiseAssigmentData({});
          // toast.error("No Record Found!!");
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error?.response?.status === 401) {
        navigate("/login");
      }
    }
  }

  console.log("assigmentDetailsassigmentDetails", assigmentDetails);
  console.log("Assigment List to Student Data =>", studentData);

  // const handleStudentHome = async (selectedStudent) => {
  //   console.log("Id of Student on Assigment List =>", selectedStudent);
  //   setStudentId(selectedStudent);
  // };

  // const handleStudentSessionIdHome = async (selectedSessionId) => {
  //   // console.log("Session Id =>",selectedSessionId);
  //   setSessionId(selectedSessionId);
  // };

  const handleChange = (e) => {
    setAssigmentDetails({
      ...assigmentDetails,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubjectName = (e) => {
    const subjectName = e.target.value;
    setAssigmentFilterDetails({ ...assigmentFilterDetails, subjectName });

    // Filter assignments based on subject name
    filterAssignments({ ...assigmentFilterDetails, subjectName });
  };

  const handleAssigmentStatus = (e) => {
    const status = e.target.value;
    setAssigmentFilterDetails({ ...assigmentFilterDetails, status });

    // Filter assignments based on status
    filterAssignments({ ...assigmentFilterDetails, status });
  };

  const filterAssignments = ({ subjectName, status }) => {
    // let filteredAssignments = dateWiseAssigmentData;
    // if (subjectName) {
    //   filteredAssignments = filteredAssignments.filter(
    //     (assignment) => assignment.name === subjectName
    //   );
    // }
    // if (status) {
    //   filteredAssignments = filteredAssignments.filter(
    //     (assignment) => assignment.assigmentstatus === status
    //   );
    // }
    if (subjectName && status) {
      let filteredAssignments = tempBody.filter(
        (assignment) =>
          assignment.subject_name === subjectName &&
          assignment.status === status
      );
      console.log("filteredAssignments@@@=>", filteredAssignments);
      setDateWiseAssigmentData(filteredAssignments);
    }
  };

  // const checkRequiredFields = () => {
  //   if (
  //     assigmentDetails.fromdate &&
  //     assigmentDetails.fromdate !== "" &&
  //     assigmentDetails.classid &&
  //     assigmentDetails.classid.trim() !== ""
  //   ) {
  //     return false;
  //   }
  //   return true;
  // };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();

      console.log("Handle-Submit-Student=Data-->>", studentData);
      console.log("assigmentDetails@!21=>", assigmentDetails);

      if (studentData?.classid) {
        assigmentDetails.classid = studentData.classid;
        assigmentDetails.section_id = studentData.section_id;
      }
      console.log("Selected-Dates-of-Assigment-->>", assigmentDetails);
      console.log("selectedSessionId@@!!=>", selectedSessionId);
      const result = await schoolApi.searchAssimentsRecords(
        assigmentDetails,
        studentData?.session_id,
      );

      if (result?.result) {
        setDateWiseAssigmentData(result.result);
        setTempBody(result.result);
        setDropDownValue(result.result);
      } else {
        setDateWiseAssigmentData({});
        toast.error("No Record Found!!");
      }
    } catch (error) {
      console.log("error-->>", error);
      if (error?.response?.status === 401) {
        navigate("/login");
      }
    }
  };

  const handlePdf = async (assigmemt) => {
    try {
      const result = await schoolApi.downloadFiles(assigmemt.file_id);
      if (result) {
        const blob = new Blob([result], { type: result.type });
        saveAs(blob, assigmemt.title);
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        navigate("/login");
      }
    }
  };
 
  return (
    <>
      <Helmet><title>Assigment List</title></Helmet>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Card className="m-3 custom-card headerOfProject">
        <Row className="g-0 ">
          <Col lg={12} className="mx-2 text-center">
            <span style={{ fontWeight: "Arial", fontSize: "15px" }}>Student Assigments</span>
          </Col>
        </Row>
      </Card>
      <Container>
        <Form onSubmit={handleSubmit} noValidate validated={validated}>
          <Row className="mx-2">
            <Col lg={2}>
              <Form.Group className="mx-2">
                <Form.Label className="form-view-label">Class Name</Form.Label>
                <Form.Control
                  name="classid"
                  value={studentData ? studentData.classname : ""}
                  disabled
                />
              </Form.Group>
            </Col>
            <Col lg={2}>
              {console.log("studentData121211=>", studentData)}
              <Form.Group className="mx-2">
                <Form.Label className="form-view-label">Section Name</Form.Label>
                <Form.Control
                  name={studentData?.sectionid ? "sectionid" : "section_id"}
                  value={studentData?.section ? studentData?.section : studentData?.section_name}
                  disabled
                />
              </Form.Group>
            </Col>
            <Col lg={3}>
              <Form.Group className="mx-2">
                <Form.Label
                  className="form-view-label"
                  htmlFor="formBasicPaymentdate"
                >
                  Start Date
                </Form.Label>
                <Form.Control
                  required
                  type="date"
                  name="fromdate"
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col lg={3}>
              <Form.Group className="mx-2">
                <Form.Label
                  className="form-view-label"
                  htmlFor="formBasicPaymentdate"
                >
                  End Date
                </Form.Label>
                <Form.Control
                  type="date"
                  name="todate"
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Button
                style={{ marginTop: "23px" }}
                variant="primary"
                onClick={handleSubmit}
              >
                Search
              </Button>
            </Col>
            {/* Filter Records Button */}
            <Col sm={2}>
              <i
                className="fa fa-filter fa-2xl text-info"
                style={{ marginTop: "36px", marginLeft: "-123px" }}
                onMouseEnter={() => setShowFilterModal(true)}
              ></i>
            </Col>
          </Row>
        </Form>
        <Row className="mt-3 mx-2">
          {showFilterModal && (
            <div
              style={{
                position: "absolute",
                background: "#ffffff",
                width: "185px",
                marginRight: "9rem",
                top: "48px",
                right: "0",
                left: "1",
                zIndex: "1",
              }}
              className="overLap"
            >
              <Row className="row p-1">
                <Col lg={12}>
                  <div
                    style={{
                      background: "#ffffff",
                      borderBottom: "1px solid black",
                      height: "2.6rem",
                      display: "flex",
                      width: "160px",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "3px",
                      boxShadow: "7px 9px 9px rgba(931, 835, 238, 0.69)",
                    }}
                  >
                    <Form.Label className="form-view-label mb-2">
                      FILTER
                    </Form.Label>
                    <i
                      className="fa fa-times fa-lg mr-5"
                      style={{ marginBottom: "4px", marginLeft: "15px" }}
                      onClick={() => setShowFilterModal(false)}
                    ></i>
                  </div>
                  <Col lg={12}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicFirstName"
                      >
                        Subject Name
                      </Form.Label>
                      <Form.Select
                        name="subjectName"
                        className="form-control"
                        onChange={handleSubjectName}
                      >
                        <option value="">-- Select Subject Name --</option>
                        {Array.isArray(dropDownValue) &&
                          [
                            ...new Set(
                              dropDownValue.map((item) => item.subject_name)
                            ),
                          ].map((subjectName) => (
                            <option key={subjectName} value={subjectName}>
                              {subjectName}
                            </option>
                          ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Form.Group>
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicFirstName"
                    >
                      Assigment Status
                    </Form.Label>
                    <Form.Select
                      name="status"
                      className="form-control"
                      onChange={handleAssigmentStatus}
                    >
                      <option value="">-- Select Status --</option>
                      {Array.isArray(dropDownValue) &&
                        [
                          ...new Set(dropDownValue.map((item) => item.status)),
                        ].map((status) => (
                          <option key={status} value={status}>
                            {status}
                          </option>
                        ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </div>
          )}
          {Array.isArray(dateWiseAssigmentData) && dateWiseAssigmentData.length > 0 && dateWiseAssigmentData.map((assignment, index) => (
                (
                  <Col lg={4} key={index} className="mt-3">
                    <Card>
                      <Card.Img variant="top" />
                      <Card.Body>
                        <Card.Title>
                          <Row>
                            <Col lg={9}>
                              <i className="fas fa-tasks fa-lg"></i>
                              &nbsp;Assignment Information {index + 1}
                            </Col>
                            <Col lg={3}>
                              {assignment.file_id ? (
                                <a
                                  href="#"
                                  onClick={() => handlePdf(assignment)}
                                  className="text-primary"
                                  style={{
                                    marginLeft: "30px",
                                    textDecoration: "none",
                                  }}
                                >
                                  <i
                                    className="fa-solid fa-download fa-xl"
                                    style={{ cursor: "pointer" }}
                                  ></i>
                                </a>
                              ) : null}
                            </Col>
                          </Row>
                        </Card.Title>
                      </Card.Body>
                      <Card.Body>
                        <Card.Title>Subject : {assignment.subject_name}</Card.Title>
                        <Card.Text>Title : &nbsp;<b>{assignment.title}</b></Card.Text>
                        <Card.Text
                          style={{
                            maxHeight: "100px",
                            overflowY: "auto",
                            whiteSpace: "pre-wrap",
                            width:"100%",
                            padding:"3px"
                          }}
                        >
                          <strong>Description:</strong> {assignment.description}
                        </Card.Text>
                      </Card.Body>
                      <ListGroup className="list-group-flush">
                        <ListGroup.Item>
                          Status : &nbsp;
                          <Badge
                            bg={
                              assignment.status === "completed"
                                ? "success"
                                : assignment.status === "assigned"
                                ? "info"
                                : assignment.status === "inprogress"
                                ? "warning"
                                : assignment.status === "cancelled"
                                ? "danger"
                                : "primary"
                            }
                          >
                            {assignment.status === "completed" ? (
                              <>Completed&nbsp;</>
                            ) : assignment.status === "assigned" ? (
                              <>Assigned&nbsp;</>
                            ) : assignment.status === "inprogress" ? (
                              <>In Progress&nbsp;</>
                            ) : assignment.status === "cancelled" ? (
                              <>Cancelled&nbsp;</>
                            ) : (
                              "Unknown"
                            )}
                          </Badge>
                          {assignment.status === "Completed" && (
                            <i className="fa fa-check ml-1 mx-2 fa-lg text-success"></i>
                          )}
                          {assignment.status === "Assigned" && (
                            <i className="fa fa-user ml-1 mx-2 fa-lg text-info"></i>
                          )}
                          {assignment.status === "In Progress" && (
                            <i className="fa fa-spinner ml-1 mx-2 fa-lg text-warning"></i>
                          )}
                          {assignment.status === "Cancelled" && (
                            <i className="fa fa-ban ml-1 mx-2 fa-lg text-danger"></i>
                          )}
                        </ListGroup.Item>
                        <ListGroup.Item>
                          Assign Date:{" "}
                          {moment(assignment.assign_date).format("DD-MM-YYYY")}
                        </ListGroup.Item>
                        <ListGroup.Item>
                          Due Date:{" "}
                          {moment(assignment.due_date).format("DD-MM-YYYY")}
                        </ListGroup.Item>
                        <ListGroup.Item>
                          Session Year: {assignment.year}
                        </ListGroup.Item>
                      </ListGroup>
                    </Card>
                  </Col>
                )
              )
            )}

          {/* Filter Assignments Records Starts Here */}

          {/* End Here */}
        </Row>
      </Container>
    </>
  );
};

export default AssigmentList;
